import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { selectDiscountsInfo } from 'src/app/store/selectors/pago.select';
import { AppState } from 'src/app/store/state/app.state';
import { BaseFacade } from 'src/app/pago/services/base-facade/BaseFacade';
import { ResumenDescuentos } from 'src/app/pago/models/ResumenDescuentos.model';

@Injectable({
  providedIn: 'root',
})
export class ResumenDescuentosFacade extends BaseFacade {
  resumenDescuentos$: Observable<ResumenDescuentos>;

  constructor(protected store: Store<AppState>) {
    super(store);

    this.resumenDescuentos$ = this.store.pipe(
      select(selectDiscountsInfo),
      filter((resumenDescuentos: ResumenDescuentos) => !!resumenDescuentos)
    );
  }
}
